module.exports = {
	"ERROR_401": "Error 401: non autorizzato",
	"ERROR_403": "Error 403: accesso negato",
	"ERROR_404": "Errore 404: non trovato",
	"ERROR": "Errore. Impossibile effettuare l'operazione richiesta",
	"NOT_AUTHORIZED": "Devi effettuare il login per visitare questa pagina",
	"FORBIDDEN": "Non hai i permessi necessari per visitare questa pagina",
	"NOT_FOUND": "Impossibile trovare la pagina richiesta",
	"CLOSE": "Chiudi",
	"SEND": "Invia",
	"ADD": "Aggiungi",
	"EDIT": "Modifica",
	"DELETE": "Elimina",
	"LIST": "Lista",
	"YES": "Si",
	"NO": "No",
	"SUBMIT": "Invia",
	"SAVE": "Salva",
	"CANCEL": "Annulla",
	"SUCCESS": "Operazione eseguita con successo",
	"REQUIRED": "Campo obbligatorio",
	"EXPECTED_NUMBER": "Campo numerico",
	"MAX_LENGTH": "Lunghezza massima {maxLength} caratteri",
	"MIN_LENGTH": "Lunghezza minima {minLength} caratteri",
	"MAX_AND_MIN_LENGTH": "Lunghezza compresa tra {minLength} e {maxLength} caratteri",
	"INVALID_FORMAT": "Formato non valido",
	"INVALID_VALUE": "Valore non valido",
	"ATTENTION": "Attenzione",
	"CONFIRM_EXIT": "Sei sicuro di voler uscire",
	"HELP": "Aiuto",
	"FINISH": "Fine",
	"NEXT": "Avanti",
	"BACK": "Indietro",
	"EXAMPLE_NUMBER": "Es. 1",
	"ALL": "Tutto",
	"ALL_PLURAL": "Tutti",
	"SET": "Imposta",
	"SET_PAGE": "Imposta pagina",
	"PREVIEW": "Anteprima",
	"SETTINGS": "Impostazioni",
	"GENERAL": "Generali",
	"NAME": "Nome",
	"THEME": "Tema",
	"COLOR": "Colore",
	"RED": "Rosso",
	"YELLOW": "Giallo",
	"BLUE": "Blu",
	"GREEN": "Verde",
	"WHITE": "Rosso",
	"LANGUAGE": "Lingua",
	"LANGUAGES": "Lingue",
	"EN": "Inglese",
	"IT": "Italiano",
	"SHORT_DESCRIPTION": "Descrizione",
	"TEMPLATE_ID": "Template",
	"ITERATION_FRAME_ID": "Tempo permanenza pagina",
	"ITERATION_ID": "Iteration",
	"DEPARTMENT_ID": "Dipartimento",
	"IPV4_LAN1": "IPv4 prima LAN",
	"PORT_LAN1": "Porta prima LAN",
	"MACADDRESS_LAN1": "Mac address prima LAN",
	"IPV4_LAN2": "IPv4 seconda LAN",
	"PORT_LAN2": "Porta seconda LAN",
	"MACADDRESS_LAN2": "Mac address seconda LAN",
	"LOCATION": "Posizione",
	"SERIAL_NUMBER": "Numero seriale",
	"FIRMWARE_VERSION": "Versione firmware",
	"TECHNICAL_NAME": "Nome del tecnico addetto",
	"NOTES": "Note",
	"IS_ACTIVE": "Attivo",
	"IPV4_LAN1_NOT_REACHABLE": "(!!!) IPv4 prima LAN",
	"IPV4_LAN2_NOT_REACHABLE": "(!!!) IPv4 seconda LAN",
	"DEPARTMENT": "Dipartimento",
	"DEPARTMENTS": "Dipartimenti",
	"NEW_DEPARTMENT": "Nuovo dipartimento",
	"EXAMPLE_DEPARTMENT": "Es: Caronno",
	"EXAMPLE_NAME": "Es: Display di Eurotranciatura",
	"EXAMPLE_LOCATION": "Es: Bollate",
	"EXAMPLE_TECHNICAL_NAME": "Es: Mario Rossi",
	"EXAMPLE_IPADDRESS": "Es: 192.168.20.30",
	"EXAMPLE_PORT": "Es: 20000",
	"EXAMPLE_MACADDRESS": "Es: 3D:F2:C9:A6:B3:4F",
	"EXAMPLE_SERIAL_NUMBER": "Es: 11111111",
	"EXAMPLE_FIRMWARE_VERSION": "Es: 1.0.1",
	"EXAMPLE_TEMPLATE_NAME": "Es: display con 2 righe",
	"INVALID_IPADDRESS": "Indirizzo Ip non valido",
	"INVALID_MACADDRESS": "Indirizzo MAC non valido",
	"INVALID_VERSION": "Versione non valida",
	"DISPLAY": "Display",
	"DISPLAYS": "Displays",
	"DISPLAY_MANAGER": "Gestore display",
	"NEW_DISPLAY": "Nuovo display",
	"DELETE_DISPLAY": "Elimina display",
	"EDIT_DISPLAY": "Modifica display",
	"GENERAL_DATA": "Dati generali",
	"TECHNICAL_DATA": "Dati tecnici",
	"FRAME_NUMBER": "Numero pagine",
	"FRAME_ORDER": "Sposta alla posizione...",
	"TIMER": "Timer",
	"TIMERS": "Timers",
	"NEW_TIMER": "Nuovo timer",
	"SECONDS": "Secondi",
	"SEC": "Sec.",
	"EXAMPLE_TIMER_NAME": "Timer veloce",
	"FREQUENCY": "Frequenza (sec.)",
	"EXAMPLE_FREQUENCY": "Es: 30",
	"TIMER_FREQUENCY": "Frequenza {seconds} sec.",
	"TEMPLATE": "Template",
	"TEMPLATES": "Templates",
	"NEW_TEMPLATE": "Nuovo template",
	"TEMPLATE_MAP": "Campi",
	"FIELD_NUM": "Campo {fieldNum}",
	"ROW_NUM": "Riga {rowNum}",
	"FRAME_NUM": "Pagina {frameNum}",
	"MAP": "Campo",
	"MAPS": "Campi",
	"NEW_MAP": "Nuovo campo",
	"FIELD": "Campo",
	"EXAMPLE_FIELD": "Es: 1",
	"ROW": "Riga",
	"EXAMPLE_ROW": "Es: 2",
	"WIDTH": "Lunghezza",
	"EXAMPLE_Width": "Es: 10",
	"DYNAMIC_FIELD": "Campo dinamico",
	"FIELD_DESCRIPTION": "Dalla pozione {start} per {length} caratteri",
	"DELETE_FIELD_ERROR": "Impossibile eliminare il campo. Assicurarsi che non sia utilizzato da nessun display.",
	"ADAPTER_NUM": "Scheda di rete",
	"MULTI_CHARACTER": "Font speciale",
	"SLIDING": "Scorrevole",
	"INTERMITTENCE": "Intermittenza",
	"INDICATOR": "Freccia",
	"POSITIVE": "Positivo",
	"NEGATIVE": "Negativo",
	"CREATE_TIMER": "Creazione timer",
	"CREATE_TEMPLATE": "Creazione template",
	"CREATE_DISPLAY": "Creazione display",
	"HELP_INTRODUCTION": "Per procedere con la creazione di un display è necessario seguire i brevi passi riportati di seguito:",
	"CREATE_TIMER_DESCRIPTION": "I timer ti consentono di stabilire con che periodicità è necessario aggiornare i display. Imposta il timer del display interessato pari al tempo di aggiornamento del campo maggiormente soggetto a cambiamenti.\nCrea un timer cliccando sull'apposita voce di menu.",
	"CREATE_TEMPLATE_DESCRIPTION": "I template ti permettono di costruire un display specificando le sue caratteristiche. I template rispecchiano essenzialmente la struttura dei vari modelli di display: è necessario descrivere ogni singolo campo nei particolari per permettere la creazione del suo modello virtuale.\nCrea un template cliccando sull'apposita voce di menu e aggiungi i campi da cui è costituito.",
	"CREATE_DISPLAY_DESCRIPTION": "La sezione display ti permette, fornendo gli opportuni dati, timer e template, di creare effettivamente i display in uso nei vari reparti. Imposta il numero di pagine per ottenere un'alternanza di testi da visualizzare dopo l'intervallo dei timer. Una volta creato un display è possibile selezionarlo per modificare i dati che dovrà mostrare.\nCrea un display cliccando sull'apposita voce di menu.",
	"CAN_CREATE_DISPLAY": "Hai terminato il tutorial, puoi iniziare ora ad impostare i display.",
	"CONFIGURATION": "Configurazione",
	"LEGEND": "Legenda",
	"TUTORIAL": "\nQuesta guida si applica solo alla prima riga del display.\nLa modalità predefinita è TESTO FISSO.\nPer scrivere una singola riga senza effetti speciali è sufficiente scrivere il testo da visualizzare.\nPer scrivere righe multiple, impostare al termine di ogni riga tranne l'ultima il carattere § (sopra la ù a fianco all'invio).\nPer attribuire ad ogni riga effetti speciali impostare prima della riga la seguenza di caratteri che impostano la modalità scelta.\nLe modalità sono:\n- font (carattere) -> i valori consentiti sono: normal (predefinito) e big. Esempio: #font=big;\n- type (modalità di visualizzazione) -> valori consentiti sono: static (predefinito) che permette la visualizzazione di testo statico, scroll che visualizza il testo in modalità scorrimento. E' possibile anche specificare la velocità di scorrimento esprimendo un valore tra 1 e 255. E' inoltre possibile indicare il tempo in secondi di permanenza della riga sul monitor nella modalità static. Esempio: #type=scroll,10; oppure #type=static,2\n- effect (effetto speciale) -> valori consentiti sono: blink (che permette di far lampeggiare il testo) stop (permette di tenere bloccato il testo della riga evitando la ripetizione). Esempio #effect:stop;\n\nNon specificando i vari attributi per le righe successive saranno mantenute le ultime impostazioni inserite.\n\nESEMPIO COMPLETO:\nVogliamo scrivere 4 righe, la prima a scorrimento a velocità 50/255 a carattere grande, la seconda e la terza carattere normale con blink che rimanga impressa per 10 secondi e la quarta con carattere grande con stop, potremmo scrivere il seguente comando:\n#font=big;#type=scroll,50;TESTO CHE SCORRE SULLA PRIMA RIGA§#font=normal;#type=static,10;#effect:blink;TESTO DA METTERE SULLA SECONDA RIGA§TESTO DA METTERE SULLA TERZA RIGA§#font=big;#effect:stop;QUARTA RIGA CON STOP\n\nSe il campo è ottenuto da un plugin, sarà compito del plugin stesso creare il testo con le modalità sopra citate.",
	"SET_CURRENT_PAGE": "Imposta pagina corrente"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/i18n/it.json
 ** module id = 820
 ** module chunks = 0
 **/